import React, { memo, useCallback, useEffect, useState } from 'react';
import { View, Text, Button, StyleSheet, StatusBar, TouchableOpacity, ActivityIndicator, FlatList } from 'react-native-web';
import { connect, useDispatch, useSelector } from "react-redux";
import { GetAppointmentDate, GetMonthName, GetYear } from '../../../shared/core/datehelper'
import { fetchMessageFromApi  } from "../../../shared/actions/MessagingActions";
import { fetchMessageById } from '../../../shared/actions/MessageDetailByIdAction';
import { clearSetItemMessage, setItemMessage } from '../../../shared/actions/SetMessageItemAction';
import Dots from "react-activity/lib/Dots";
import 'react-activity/lib/Dots/Dots.css';

import MessageItem from "../../components/MessageItem";
import { getInitials } from '../../../shared/core/utils';
import MessageView from '../../components/MessageView';
import getUserId from '../../../shared/core/GetToken';
import { Link, useNavigate } from 'react-router-dom';
import { appServices } from '../../../shared/redux/actions/appServices';
import getUserInfo from '../../../shared/core/GetTokenized';
const Received = props => {
    
    const information =  getUserInfo(); // Get the user info (will resolve the promise)
    const PatienInformation = JSON.parse(information);
    const { SendMessage, isSending, isSendMessageSuccess, error } = useSelector((state)=>state.NewMessages)
    const { Profile, isFetching } = useSelector((state)=> state.PatientProfile)
    //  const { Messaging, isGetting } = props.Messaging;         
    // const { Messaging, isGetting } = props.Messaging;                   //loading main message
    const { Messaging, isGetting } = useSelector((state)=> state.Messaging)
    // const { MessageDetail, isGettingById } = props.MessageDetail;       //get message details by id
    const [pageSize, setPageSize] = useState(100);                      //state for the page number
    const [pageNumber, setPageNumber] = useState(1);  
    const dispatch= useDispatch() 
    const msgObj={
        PatientID: Profile && Profile[0].resource.id,
        PageSize  : pageSize,
        PageNumber: pageNumber ,
        Type :1,
        MessagingType : 1,
    }               
    useEffect(() => {
        //alert('Called Future')
        if(props.activeKey==="1" && Profile){
        dispatch (appServices.Messaging(msgObj)
        )
    }
        // props.getMessage(pageSize, pageNumber)
    }, [props.activeKey , SendMessage , Profile])


    const getMessageId = params => {
        console.log("for Hassan====>  " + params)
        props.setMessageItem(params, 'Received')
    }

   

    return (
        <>
            {
                isGetting && <View style={{ textAlign: 'center', marginTop: 5 }}><ActivityIndicator size="small" color="#00A1DE" /></View>
            }
            {
                Messaging && Messaging.length ? (
                    <FlatList
                        style={{ marginTop: 0, height: 700 }}
                        data={Messaging}
                        renderItem={({ item }) => (
                            // <TouchableOpacity onPress={() => {
                            //     getMessageId(item.resource.id)
                            // }}>
                        
                            // <Link to={{
                            //     pathname: '/read',
                            //     state: { "replyid": item.resource.id, "reply": true }
                            // }}>
                            <div
                            >
                                <MessageItem
                                    initails={getInitials(item.resource.extension[2].valueString)}
                                    messageDate={GetAppointmentDate(item.resource.extension[6].valueDateTime) + ' ' + GetMonthName(item.resource.extension[6].valueDateTime)}
                                    sender={item.resource.extension[2].valueString}
                                    messageSubject={item.resource.note[0].text}
                                    messageDescription={item.resource.extension[0].valueString}
                                    readStatus={item?.resource?.extension[5]?.valueString}
                                    replyid={item.resource.id}
                                />
                                </div>
                               
                            // </Link>
                        )}
                        keyExtractor={item => item.resource.id}
                        initialNumToRender={10}
                        maxToRenderPerBatch={2}
                        windowSize={7}

                    />

                ) : !isGetting && <View style={{
                    flexDirection: "column",
                    justifyContent: 'center', alignItems: 'center'
                }}>
                    <Text style={{ marginTop: 10, }}>No Records Found</Text>
                </View>
            }
        </>
    );
}


// function mapStateToProps(state) {
//     return {
//         Messaging: state.Messaging,
//         MessageDetail: state.MessageDetail,
//         // SetMessageItem: state.SetMessageItem,
//     }
// }
// function mapDispatchToProps(dispatch) {
//     return {
//         // getMessage: (pageSize, pageNumber) => dispatch(fetchMessageFromApi(pageSize, pageNumber)),
//         // getMessageByid: (messageId) => dispatch(fetchMessageById(messageId)),
//         setMessageItem: (item, screenName) => dispatch(setItemMessage(item, screenName)),
//     }
// }

// export default connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(Received);

export default Received
